"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsRRule = exports.isRRule = void 0;
const isNil_1 = __importDefault(require("lodash/isNil"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
const isString_1 = __importDefault(require("lodash/isString"));
const rrule_1 = require("rrule");
const Exists_1 = require("../common/Exists");
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
async function isRRule(value, args, constraints) {
    const existsResults = await (0, Exists_1.exists)(value, args, {
        isOptional: constraints === null || constraints === void 0 ? void 0 : constraints.isOptional,
        if: constraints === null || constraints === void 0 ? void 0 : constraints.if,
        allowEmptyString: false,
    });
    if (existsResults.pass === false || existsResults.skipped) {
        return existsResults;
    }
    if (value instanceof rrule_1.RRule) {
        return { pass: true };
    }
    if (!(0, isString_1.default)(value)) {
        return { pass: false, message: `should be a string or RRule` };
    }
    try {
        const rruleOptions = rrule_1.RRule.parseString(value);
        if (!(0, isNil_1.default)(rruleOptions.interval) && !(0, isNumber_1.default)(rruleOptions.interval)) {
            return { pass: false, message: `should have a valid interval` };
        }
        if (!(0, isNil_1.default)(rruleOptions.count) && !(0, isNumber_1.default)(rruleOptions.count)) {
            return { pass: false, message: `should have a valid count` };
        }
        const parsedRRule = rrule_1.RRule.optionsToString(rruleOptions);
        if (parsedRRule !== value && parsedRRule !== `RRULE:${value}`) {
            return { pass: false, message: `should be a valid RRule` };
        }
    }
    catch (e) {
        return { pass: false, message: `should be a valid RRule` };
    }
    return { pass: true };
}
exports.isRRule = isRRule;
/**
 * Validates that this value is a valid RRule
 */
function IsRRule(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsRRule",
        defaultMessage: `should be a valid RRule`,
        options,
        constraints,
        validateFn: isRRule,
    });
}
exports.IsRRule = IsRRule;
//# sourceMappingURL=IsRRule.js.map